const getAppInfo = (state) => state.appInfo || {};

export const getAppVersion = (state) => getAppInfo(state).version;
